import script from "./WelcomeOnboardingDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeOnboardingDialog.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeOnboardingDialog.vue?vue&type=style&index=0&id=6013c6e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6013c6e0"]])

export default __exports__